module.exports = __webpack_public_path__ + "img/xa2u.ce6f9374.png";